<template>
  <ul
    v-for="item in menu"
    :key="item.title"
    class="flex flex-col gap-2"
  >
    <router-link
      :to="item.link"
      class="router__title"
      v-show="item.isRender !== false"
      @click="$emit('closeMenu')"
    >
      {{ item.title }}
    </router-link>

    <div class="flex flex-col gap-2">
      <div
        class="router__children"
        v-for="children in item.children"
        :key="children.title"
        @click="$emit('closeMenu')"
      >
        <!-- 유닛 하위메뉴 -->
        <SubMenuUnit v-if="['그룹', '유닛'].includes(children.title)" />
        <router-link
          :to="children.link"
          v-else
        >
          {{ children.title }}
        </router-link>
      </div>
      <a
        :href="gotchaLink"
        target="_blank"
        v-if="item.title === '주문접수' && isOpenGotcha"
        class="router__children"
        >세차접수</a
      >
      <a
        :href="manualLink"
        target="_blank"
        v-if="item.title === '공지사항'"
        class="router__children"
        >이용가이드</a
      >
    </div>
  </ul>
</template>
<script lang="ts" setup>
import { toRefs, computed } from 'vue';
import SubMenuUnit from '@/components/ui/mypage/submenu/Unit.vue';

import type { Menu } from '@/lib/constants/gnbMenuMap';
const props = defineProps<{
  menu: Menu[];
}>();

const emit = defineEmits<{
  (event: 'closeMenu'): void;
}>();

const { menu } = toRefs(props);
const isOpenGotcha = computed(() => {
  // const gotchaOpenCenter =
  //   import.meta.env.VITE_ENV === "master"
  //     ? "62d501d545b113001cb20ed2"
  //     : "62a1729a6352c9001c985238";
  // return center.value.centerId === gotchaOpenCenter;
  return false;
});
const gotchaLink = 'https://bit.ly/3tPe5ba';
const manualLink = 'https://krcodver.notion.site/krcodver/9867dc96cda84220a9d7ae489528c966';
</script>
<style lang="scss" scoped>
.router {
  &__title {
    @apply font-bold text-lg;

    &.router-link-active {
      color: var(--black9) !important;
    }
  }
  &__children {
    @apply text-black7 text-sm;

    &.router-link-active {
      color: var(--black7) !important;
    }
  }
}
</style>
